import { useState } from 'react'
import { MdVerified } from 'react-icons/md'

const HEART_PATH =
  'M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z'
const VERIFIED_PATH =
  'M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.307 4.491 4.491 0 0 1-1.307-3.497A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z'
const ARROW_PATH = 'M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3'
const BELL_PATH =
  'M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0'

function StarRow({ rating, reviews }) {
  const filled = Math.floor(rating)
  return (
    <div className="flex items-center gap-1 mb-3">
      {Array.from({ length: 5 }, (_, i) => (
        <span key={i} className={`${i < filled ? 'star-w' : 'star-w-e'} text-[12px]`}>
          ★
        </span>
      ))}
      {rating > 0 ? (
        <>
          <span className="text-[9px] font-bold ml-1" style={{ color: '#C8922A' }}>
            {rating.toFixed(1)}
          </span>
          <span className="text-[8px]" style={{ color: '#A08870' }}>
            ({reviews} review{reviews !== 1 ? 's' : ''})
          </span>
        </>
      ) : (
        <span className="text-[8px] ml-1" style={{ color: '#A08870' }}>
          No reviews yet
        </span>
      )}
    </div>
  )
}

export default function AstrologerCard({ astro, revealed, hidden }) {
  const [imgFailed, setImgFailed] = useState(false)
  const [isFav, setIsFav] = useState(false)
  const isNotify = astro.ctaLabel === 'Notify Me'

  return (
    <div
      className={`astro-w-wrap${revealed ? ' w-in-view' : ''}${hidden ? ' w-hidden-card' : ''}`}
      data-name={astro.name.toLowerCase()}
      role="link"
      tabIndex={0}
      style={{ cursor: 'pointer' }}
      onClick={() => { window.location.href = astro.detailsHref }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          window.location.href = astro.detailsHref
        }
      }}
    >
      <div className="astro-pro-card group">
        <div className="astro-pro-photo">
          <div className="astro-pro-fallback" style={{ background: astro.fallbackGradient }}>
            <div className="text-center select-none">
              <div style={{ fontSize: '60px', lineHeight: 1, opacity: 0.35 }}>✦</div>
              <div className="font-royal text-5xl font-bold mt-1" style={{ color: astro.fallbackLetterColor }}>
                {astro.fallbackLetter}
              </div>
            </div>
          </div>
          {astro.image && !imgFailed && (
            <img src={astro.image} alt={astro.name} loading="lazy" onError={() => setImgFailed(true)} />
          )}

          {astro.ribbon && <div className="feat-ribbon">{astro.ribbon}</div>}

          <div className="absolute top-3 inset-x-3 flex items-center justify-between z-10">
            {astro.status === 'live' ? (
              <div className="s-live flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[8px] font-bold uppercase tracking-wider">
                <div className="relative w-1.5 h-1.5">
                  <div className="live-ring absolute inset-0 rounded-full" style={{ background: 'rgba(34,197,94,.4)' }} />
                  <div className="w-1.5 h-1.5 rounded-full" style={{ background: '#22c55e' }} />
                </div>
                Live
              </div>
            ) : (
              <div className="s-busy flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[8px] font-bold uppercase tracking-wider">
                <div className="busy-blink w-1.5 h-1.5 rounded-full" style={{ background: '#D97706' }} />
                Busy
              </div>
            )}
            {/* <button
              type="button"
              className={`fav-btn${isFav ? ' is-fav' : ''}`}
              onClick={(e) => {
                e.stopPropagation()
                setIsFav((v) => !v)
              }}
              aria-label="Add to favourites"
            >
              <svg
                className="fav-ico w-3.5 h-3.5"
                fill={isFav ? '#ef4444' : 'none'}
                stroke={isFav ? '#ef4444' : '#8B7355'}
                strokeWidth="2.2"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d={HEART_PATH} />
              </svg>
            </button> */}
          </div>

          <div className="absolute inset-x-0 bottom-0 z-10">
            <span
              className="inline-flex items-center gap-1 text-[7.5px] font-black uppercase tracking-wider px-2.5 py-1 rounded-full"
              style={{ ...astro.categoryTagStyle, backdropFilter: 'blur(8px)' }}
            >
              {astro.categoryTag}
            </span>
          </div>
        </div>

        <div className="astro-card-body">
          {/* Reserve two title lines so 1-line names don't pull the rows below up. */}
          <div className="flex items-center">
            <MdVerified fill='#22c55e' size={14} className='self-start' />
            <h3 className="font-royal text-black text-[20px] font-bold leading-tight"> {astro.name} </h3>
          </div>

          <p className="text-[9px] uppercase tracking-[.18em] mb-3" style={{ color: '#9A7A58' }}>
            {astro.role}
          </p>

          <div className="grid grid-cols-3 gap-1.5 mb-3">
            <div className="flex flex-col items-center py-2 rounded-xl" style={{ background: 'rgba(200,146,42,.06)', border: '1px solid rgba(200,146,42,.1)' }}>
              <span className="font-royal text-[12px] font-bold leading-tight" style={{ color: '#1C0A03' }}>
                {astro.experience}
              </span>
              <span className="text-[6px] uppercase tracking-wide mt-0.5" style={{ color: '#9A7A58' }}>
                Exp
              </span>
            </div>
            <div className="flex flex-col items-center py-2 rounded-xl" style={{ background: 'rgba(200,146,42,.06)', border: '1px solid rgba(200,146,42,.1)' }}>
              <span className="font-royal text-[12px] font-bold leading-tight" style={{ color: '#1C0A03' }}>
                {astro.duration}
              </span>
              <span className="text-[6px] uppercase tracking-wide mt-0.5" style={{ color: '#9A7A58' }}>
                Session
              </span>
            </div>
            <div className="flex flex-col items-center py-2 rounded-xl" style={{ background: 'rgba(200,146,42,.06)', border: '1px solid rgba(200,146,42,.1)' }}>
              <span className="font-royal text-[12px] font-bold leading-tight" style={{ color: '#C8922A' }}>
                {astro.ratingBadge}
              </span>
              <span className="text-[6px] uppercase tracking-wide mt-0.5" style={{ color: '#9A7A58' }}>
                Rating
              </span>
            </div>
          </div>

          <StarRow rating={astro.rating} reviews={astro.reviews} />

          <div className="flex flex-wrap gap-1.5 mb-3">
            {(astro.languages.length ? astro.languages : ['Hindi']).slice(0, 3).map((lang) => (
              <span key={lang} className="meta-pill">
                {lang === 'Hindi' ? '🇮🇳 ' : ''}
                {lang}
              </span>
            ))}
            {astro.languages.length > 3 && (
              <span className="meta-pill">+{astro.languages.length - 3}</span>
            )}
          </div>

          {/* mt-auto pins the price/CTA row to the card bottom in equal-height rows. */}
          <div className="astro-divider mb-3.5 mt-auto" />

          <div className="flex items-end justify-between">
            <div>
              <div className="font-royal text-[22px] font-bold leading-tight" style={{ color: '#C8922A' }}>
                {astro.price}
              </div>
              <div className="text-[7px] uppercase tracking-widest" style={{ color: '#9A7A58' }}>
                per session
              </div>
            </div>
            <a
              href={astro.ctaHref}
              onClick={(e) => e.stopPropagation()}
              className="book-btn-w flex items-center gap-1.5 px-4 py-2.5 rounded-xl text-[9px] font-bold uppercase tracking-widest transition-all"
              style={
                isNotify
                  ? { background: 'linear-gradient(135deg,#3A1A00,#5A2E00)', color: '#FDE68A', boxShadow: '0 6px 18px -4px rgba(58,26,0,.4)' }
                  : { background: 'linear-gradient(135deg,#1C0A03,#2E1206)', color: '#E5A820', boxShadow: '0 6px 18px -4px rgba(28,10,3,.35)' }
              }
              onMouseOver={(e) => {
                e.currentTarget.style.background = 'linear-gradient(135deg,#C8922A,#E5A820)'
                e.currentTarget.style.color = '#1C0A03'
                e.currentTarget.style.boxShadow = '0 6px 18px -4px rgba(200,146,42,.5)'
              }}
              onMouseOut={(e) => {
                if (isNotify) {
                  e.currentTarget.style.background = 'linear-gradient(135deg,#3A1A00,#5A2E00)'
                  e.currentTarget.style.color = '#FDE68A'
                  e.currentTarget.style.boxShadow = '0 6px 18px -4px rgba(58,26,0,.4)'
                } else {
                  e.currentTarget.style.background = 'linear-gradient(135deg,#1C0A03,#2E1206)'
                  e.currentTarget.style.color = '#E5A820'
                  e.currentTarget.style.boxShadow = '0 6px 18px -4px rgba(28,10,3,.35)'
                }
              }}
            >
              {astro.ctaLabel}
              <svg className="w-3 h-3" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d={isNotify ? BELL_PATH : ARROW_PATH} />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
